<template>
	<div class="history" :class="{ 'history__full-height': isFullHeight }">
		<h5 class="history__h5">Aricle history:</h5>
		<div class="history__container custom-scrollbar">
			<router-link
				class="history__article hyper-click-primary"
				v-for="(ha, i) in articleHistory"
				:key="i"
				:to="{
					path: '/article-view',
					query: { historyId: ha.articleHistoryId },
				}"
			>
				<span class="history__article-edited-on">{{
					updatedOn[i]
				}}</span>
				by
				<span class="history__article-edited-by">{{
					ha.userCache.userName
				}}</span>
			</router-link>
			<p
				v-if="articleHistory.length === 0 && !errMsg && !loading"
				class="text-secondary"
			>
				This article has no previous versions!
			</p>
			<ErrorAlert v-if="errMsg" :error="errMsg" />
			<Spinner v-if="loading" />
		</div>
	</div>
</template>

<script>
import dayjs from "dayjs";
import ArticleHistory from "../../../services/article-history";
import ErrorAlert from "../../shared/ErrorAlert";
import Spinner from "../../shared/Spinner";

export default {
	name: "SiderticleHistory",
	props: ["articleId", "isFullHeight"],
	components: {
		ErrorAlert,
		Spinner,
	},
	data() {
		return {
			articleHistory: [],
			loading: false,
			errMsg: null,
		};
	},
	mounted() {
		this.getArticleHistoryList();
	},
	methods: {
		getArticleHistoryList: function () {
			if (!this.articleId) return;
			this.loading = true;
			ArticleHistory.instance()
				.getArticleHistoryList(this.articleId)
				.then((res) => {
					this.articleHistory = res.data.sort(
						(a, b) => b.updatedOn - a.updatedOn
					);
					this.loading = false;
				})
				.catch((err) => {
					this.errMsg = err;
					this.loading = false;
				});
		},
	},
	computed: {
		updatedOn: function () {
			return this.articleHistory.map((ha) =>
				dayjs(ha.updatedOn).format("DD MMM YYYY HH:mm:ss")
			);
		},
	},
	watch: {
		articleId: function () {
			this.getArticleHistoryList();
		},
	},
};
</script>

<style scoped>
.history {
	height: 300px;
	padding: 24px 0 0 20px;
}
.history__container {
	height: calc(100% - 50px);
	overflow: auto;
	padding: 10px 20px 10px 0;
}
.history__article {
	display: block;
}
</style>